export default "__VITE_ASSET__CJ5Z1wRy__"